export default function getResource(label, vars = []) {
    const resources = {
        freeReturns: 'Retours gratuits sur tous les achats*',
        infoIcon: 'Renseignements sur les retours gratuits',
        applyNow: 'S’inscrire ▸',
        offerForYou: '<b>Offre pour vous : </b>Inscrire le code ',
        offerForYouCode: `<b>${vars[0]}</b> pour obtenir ${vars[1]} % de réduction sur n’importe quel essentiel ${vars[2]}.`,
        promoInfoModalTitle: 'Avis de non-responsabilité/renseignements sur votre offre'
    };

    return resources[label];
}
